import { Container, Box, Link, Heading } from '@chakra-ui/react';
import { APICall } from '../../types';
import { Loading } from '../atoms/loading';
import { UniLogo } from '../atoms/uni-logo';

interface IProps {
  children: React.ReactNode;
  apiCallsInProgress: APICall[];
  isLoading?: boolean;
  heading?: React.ReactNode | string;
}

const LoginWrapper = (props: IProps) => {
  const { children, apiCallsInProgress, isLoading, heading } = props;

  return (
    <Box w="100vw" h="100vh" overflow="auto" bgColor="utility.900" _dark={{ bgColor: 'gray.800' }}>
      <Loading
        show={isLoading || (apiCallsInProgress && apiCallsInProgress.length > 0)}
        apiCallsInProgress={apiCallsInProgress}
      />

      <Container maxW="lg" pt={{ base: 8, sm: 16 }} pb={12}>
        <Link href="/" display="flex" justifyContent="center" mb={{ base: 8, sm: 12 }}>
          <UniLogo />
        </Link>

        <Box
          as="main"
          data-selector="content-wrap"
          bgColor="chakra-body-bg"
          color="chakra-body-text"
          borderRadius="3xl"
          px={{ base: 6, sm: 14 }}
          py={{ base: 8, sm: 12 }}
        >
          <Heading as="h1" fontSize="3xl" mb={6}>
            {heading}
          </Heading>

          {children}
        </Box>
      </Container>
    </Box>
  );
};

export default LoginWrapper;
